import { FilterOperator } from "../../context/FiltersProvider/types";

export const MULTI_OPERATORS: FilterOperator[] = ["in", "not in"];

export const NO_VALUE_OPERATORS: FilterOperator[] = ["is null", "is not null"];

export const isMultiOperator = (op: FilterOperator) => MULTI_OPERATORS.includes(op);

export const isNoValueOperator = (op: FilterOperator) => NO_VALUE_OPERATORS.includes(op);
